const fakeData = {
  id: 4707,
  quizTitle: 'Lớp 4 - Reading',
  jsonData: {
    questions: [
      {
        id: 5106,
        examinationId: '369B9103-BF93-4CF7-B94E-2D54254E548C',
        questionText: 'We are doctors.',
        answers: [
          {
            id: 1,
            answer: '',
            isCorrect: true,
          },
        ],
        type: 'TickTF',
        optionType: 'TICKTF_ONE_TICKORCROSS',
        grade: 'ELEMENTARY',
        title: 'Tick or cross  in the box.',
        subTile: 'Đánh dấu (✔) - đúng hoặc (X) - sai vào ô trống. ',
        componentType: 'TickTF',
        settings: {},
        audioUrl: '',
        imageUrl: 'https://cloud.softech.vn/storage/SACHSO/t_SACHSO_RESOURCES_Questions/46d30c13-3555-4395-8b83-4b9b2f7402ae/fd12e048-de99-42c4-9888-25ecb2bc65c0/1. We_re doctors..jpg',
      },
      {
        id: 5026,
        questionText: '',
        answers: [
          {
            id: 1,
            question: 'Màu đỏ',
            answer: 'https://cloud.softech.vn/storage/SachSo/Images/Vocabulary/Starters/red.png',
            isCorrect: true,
          },
          {
            question: 'Màu nâu',
            answer: 'https://cloud.softech.vn/storage/SachSo/Images/Vocabulary/Starters/yellow.png',
            isCorrect: false,
            id: 2,
          },
        ],
        type: 'TickTF',
        optionType: 'TICKTF_ANY_TICKORCROSS',
        gradeCode: 'ELEMENTARY',
        title: 'Tick or cross in the boxes.',
        subTitle: 'Đánh dấu (✔) - đúng hoặc (X) - sai vào ô trống với mỗi câu sau. ',
        tags: 'Lớp 1',
        gradeName: 'Nhận biết',
        componentType: 'TickTF',
        skills: 'V',
        imageUrl: '',
        imageSvg: '',
        audioUrl: '',
        settings: {},
        status: 'PUBLIC',
        createBy: 42327,
      },
      {
        id: 4926,
        questionText: "Mia doesn't find the subject she mentioned beneficial.",
        answers: [
          {
            answer: '',
            isCorrect: false,
            id: 1,
          },
        ],
        type: 'TICKTF',
        optionType: 'TICKTF_TRUEORFALSE',
        gradeCode: 'ELEMENTARY',
        title: 'Tick True or False.',
        subTitle: 'Đánh dấu (✓) vào ô True hoặc False.',
        tags: 'Lớp 10',
        gradeName: 'Nhận biết',
        componentType: 'TICKTF',
        skills: 'Vocabulary&Structure',
        imageUrl: null,
        imageSvg: '',
        audioUrl: null,
        settings: {},
        status: 'PUBLIC',
        createBy: 42327,
      },
      {
        id: 5107,
        examinationId: '369B9103-BF93-4CF7-B94E-2D54254E548C',
        questionText: 'They are teachers. ',
        answers: [
          {
            id: 1,
            answer: '',
            isCorrect: true,
          },
        ],
        type: 'TickTF',
        optionType: 'TICKTF_ONE_TICKORCROSS',
        grade: 'ELEMENTARY',
        title: 'Tick or cross  in the box.',
        subTile: 'Đánh dấu (✔) - đúng hoặc (X) - sai vào ô trống. ',
        componentType: 'TickTF',
        settings: {},
        audioUrl: '',
        imageUrl: 'https://cloud.softech.vn/storage/SACHSO/t_SACHSO_RESOURCES_Questions/46d30c13-3555-4395-8b83-4b9b2f7402ae/2a5e442c-17a8-4d98-b3b4-5cbfc3dcd25b/2. They_re teachers..jpg',
      },

      {
        id: 4922,
        questionText:
          'My name is Annie. This is my room. I have got lots of toys. My ___ is red. My ___ is pink, blue and yellow. My three ___ are red. I have got two ___ They are brown. I like playing baseball and I really love my ___My favorite toy is ___It is colorful.',
        answers: [
          {
            id: 1,
            answer: 'car',
            isCorrect: true,
          },
          {
            id: 2,
            answer: 'ball',
            isCorrect: true,
          },
          {
            id: 3,
            answer: 'apples',
            isCorrect: true,
          },
          {
            id: 4,
            answer: 'teddy bears',
            isCorrect: true,
          },
          {
            id: 5,
            answer: 'bat',
            isCorrect: true,
          },
          {
            id: 6,
            answer: 'kite',
            isCorrect: true,
          },
        ],
        type: 'FILLINTHEBLANK',
        optionType: 'FILLINTHEBLANK_CHOOSEWORD',
        gradeCode: 'ELEMENTARY',
        title: 'Read the text. Choose the word from the box. Write the word next to numbers 1-5.',
        subTitle: 'Đọc và chọn từ trong khung cho sẵn. Viết đáp án bên cạnh các số từ 1 – 5.',
        tags: 'Lớp 1',
        gradeName: 'Nhận biết',
        componentType: 'FillInTheBlank',
        skills: 'W',
        imageUrl: '',
        imageSvg: '',
        audioUrl: '',
        settings: {},
        status: 'PUBLIC',
        createBy: 42327,
      },
      {
        id: 5177,
        questionText:
          'This is my bedroom. My ___ is pink and blue. My ___ so cute. She is wearing blue jeans. My two ___ are blue and yellow. I have got one ___ It is grey. It is so funny. I like playing with my ___ It is green and red. My favorite toy is ___ It is red.',
        answers: [
          {
            answer: 'bag',
            isCorrect: true,
            id: 1,
          },
          {
            answer: 'doll',
            isCorrect: true,
            id: 2,
          },
          {
            answer: 'yo-yos',
            isCorrect: true,
            id: 3,
          },
          {
            answer: 'robot',
            isCorrect: true,
            id: 4,
          },
          {
            answer: 'train',
            isCorrect: true,
            id: 5,
          },
          {
            answer: 'car',
            isCorrect: true,
            id: 6,
          },
        ],
        type: 'FILLINTHEBLANK',
        optionType: 'FILLINTHEBLANK_CHOOSEWORD',
        gradeCode: 'INTERMEDIATE',
        title: 'Read the text. Choose the word from the box. Write the word next to numbers 1-5.',
        subTitle: 'Đọc và chọn từ trong khung cho sẵn. Viết đáp án bên cạnh các số từ 1 – 5.',
        tags: 'Lớp 4',
        gradeName: 'Vận dụng',
        componentType: 'FillInTheBlank',
        skills: 'W',
        imageUrl: null,
        imageSvg: '',
        audioUrl: null,
        settings: {},
        status: 'PUBLIC',
        createBy: 42327,
      },
      {
        id: 5015,
        examinationId: '369B9103-BF93-4CF7-B94E-2D54254E548C',
        questionText: 'He works in a police station. ___',
        answers: [
          {
            answer: 'yes',
            isCorrect: true,
            id: 1,
          },
        ],
        type: 'FILLINTHEBLANK',
        optionType: 'FILLINTHEBLANK_LOOKANREADYES/NO',
        grade: 'ELEMENTARY',
        title: 'Look and read. Write Yes or No.',
        subTile: 'Đọc và viết Yes hoặc No.',
        componentType: 'FillInTheBlank',
        settings: {},
        imageUrl: 'https://cloud.softech.vn/storage/SACHSO/t_SACHSO_RESOURCES_Questions/46d30c13-3555-4395-8b83-4b9b2f7402ae/d304e3b3-5d42-4720-a546-41eb292b4f1f/1.jpg',
      },
      {
        id: 5016,
        examinationId: '369B9103-BF93-4CF7-B94E-2D54254E548C',
        questionText: 'She works in a school. ___',
        answers: [
          {
            answer: 'no',
            isCorrect: true,
            id: 1,
          },
        ],
        type: 'FILLINTHEBLANK',
        optionType: 'FILLINTHEBLANK_LOOKANREADYES/NO',
        grade: 'PREINTERMEDIATE',
        title: 'Look and read. Write Yes or No.',
        subTile: 'Đọc và viết Yes hoặc No.',
        componentType: 'FillInTheBlank',
        settings: {},
        imageUrl: 'https://cloud.softech.vn/storage/SACHSO/t_SACHSO_RESOURCES_Questions/46d30c13-3555-4395-8b83-4b9b2f7402ae/7f6db3d2-b77f-4946-9cf4-09f2e6563ce2/2.jpg',
      },
      {
        id: 5019,
        examinationId: '369B9103-BF93-4CF7-B94E-2D54254E548C',
        questionText: 'Does Nam work in the zoo? ___\r\n',
        answers: [
          {
            answer: 'yes',
            isCorrect: true,
            id: 1,
          },
        ],
        type: 'FILLINTHEBLANK',
        optionType: 'FILLINTHEBLANK_LOOKANREADYES/NO',
        grade: 'ELEMENTARY',
        title: 'Look and read. Write Yes or No.',
        subTile: 'Đọc và viết Yes hoặc No.',
        componentType: 'FillInTheBlank',
        settings: {},
        imageUrl: 'https://cloud.softech.vn/storage/SACHSO/t_SACHSO_RESOURCES_Questions/46d30c13-3555-4395-8b83-4b9b2f7402ae/d6062457-e442-4a5b-9b6b-7c87ffe8245f/5.jpg',
      },
      {
        id: 4773,
        questionText: 'I ___ (love) you.',
        answers: [
          {
            answer: 'love',
            isCorrect: false,
            id: 1,
          },
        ],
        type: 'WordForm',
        optionType: 'FILLINTHEBLANK_USECORRECT',
        gradeCode: 'ELEMENTARY',
        title: 'Use the correct form of the word given in each sentence.',
        subTitle: 'Cho hình thức, thể thức của từ cho trước.',
        tags: 'Tất cả các lớp',
        gradeName: 'Nhận biết',
        componentType: 'FillInTheBlank',
        skills: 'V',
        imageUrl: '',
        imageSvg: '',
        audioUrl: '',
        settings: {},
        status: 'PUBLIC',
        createBy: 23195,
      },
      {
        id: 4664,
        examinationId: '97A7E14E-3F4E-4AFD-96E2-AF0F8E3D9646',
        questionText: 'What does her brother do?',
        answers: [
          {
            answer: 'https://cloud.softech.vn/storage/SACHSO/t_SACHSO_RESOURCES_Questions/46d30c13-3555-4395-8b83-4b9b2f7402ae/4abde221-555b-4f62-b2e0-8fcd4c0ffb02/1pilot.png',
            isCorrect: true,
            id: 1,
          },
          {
            answer: 'https://cloud.softech.vn/storage/SACHSO/t_SACHSO_RESOURCES_Questions/46d30c13-3555-4395-8b83-4b9b2f7402ae/51cf2781-e60a-4287-8b71-c79496136e3a/2teacher.png',
            isCorrect: false,
            id: 2,
          },
          {
            answer: 'https://cloud.softech.vn/storage/SACHSO/t_SACHSO_RESOURCES_Questions/46d30c13-3555-4395-8b83-4b9b2f7402ae/30d2884e-d72d-44f2-8143-443892177185/3farmer.png',
            isCorrect: false,
            id: 3,
          },
        ],
        type: 'MULTIPLECHOICE',
        optionType: 'LISTENPICTURE',
        grade: 'PREINTERMEDIATE',
        title: 'Listen and choose correct image.',
        subTile: 'Nghe và chọn hình ảnh mô tả đúng.',
        componentType: 'MultipleChoice',
        settings: {
          answers: {
            bulletType: 'character',
            imageAnswers: true,
            columnImageAnswers: 3,
          },
        },
        audioUrl: 'https://cloud.softech.vn/storage/SACHSO/t_SACHSO_RESOURCES_Questions/46d30c13-3555-4395-8b83-4b9b2f7402ae/ca414b6c-7f90-4f40-88a3-b0d87c60c0cb/UNIT-1_CÂU-1.wav',
      },
      {
        id: 4666,
        examinationId: '97A7E14E-3F4E-4AFD-96E2-AF0F8E3D9646',
        questionText: 'What does Rosy’s dad do?',
        answers: [
          {
            answer: 'https://cloud.softech.vn/storage/SACHSO/t_SACHSO_RESOURCES_Questions/46d30c13-3555-4395-8b83-4b9b2f7402ae/cfadb900-9a43-452f-a9f6-9802df0b8163/1farmer.png',
            isCorrect: false,
            id: 1,
          },
          {
            answer: 'https://cloud.softech.vn/storage/SACHSO/t_SACHSO_RESOURCES_Questions/46d30c13-3555-4395-8b83-4b9b2f7402ae/1da0284b-8efc-4a45-98b6-d4c89cb881ec/2doctor.png',
            isCorrect: false,
            id: 2,
          },
          {
            answer: 'https://cloud.softech.vn/storage/SACHSO/t_SACHSO_RESOURCES_Questions/46d30c13-3555-4395-8b83-4b9b2f7402ae/264639b3-0c37-4cb0-8a85-d3cf99e1aa60/3teacher.png',
            isCorrect: true,
            id: 3,
          },
        ],
        type: 'MULTIPLECHOICE',
        optionType: 'LISTENPICTURE',
        grade: 'PREINTERMEDIATE',
        title: 'Listen and choose correct image.',
        subTile: 'Nghe và chọn hình ảnh mô tả đúng.',
        componentType: 'MultipleChoice',
        settings: {
          answers: {
            bulletType: 'character',
            imageAnswers: true,
            columnImageAnswers: 3,
          },
        },
        audioUrl: 'https://cloud.softech.vn/storage/SACHSO/t_SACHSO_RESOURCES_Questions/46d30c13-3555-4395-8b83-4b9b2f7402ae/166b2486-07a9-4614-8b3c-59d4d504f216/UNIT-1_CÂU-2.wav',
      },
      {
        id: 4668,
        examinationId: '97A7E14E-3F4E-4AFD-96E2-AF0F8E3D9646',
        questionText: 'What does his cousin do?',
        answers: [
          {
            answer: 'https://cloud.softech.vn/storage/SACHSO/t_SACHSO_RESOURCES_Questions/46d30c13-3555-4395-8b83-4b9b2f7402ae/9f229f05-a4ad-4b3a-a91a-af771380aa02/1pilot.png',
            isCorrect: false,
            id: 1,
          },
          {
            answer: 'https://cloud.softech.vn/storage/SACHSO/t_SACHSO_RESOURCES_Questions/46d30c13-3555-4395-8b83-4b9b2f7402ae/0edfc0b3-e04d-4562-892f-e0d5db99a316/2doctor.png',
            isCorrect: true,
            id: 2,
          },
          {
            answer: 'https://cloud.softech.vn/storage/SACHSO/t_SACHSO_RESOURCES_Questions/46d30c13-3555-4395-8b83-4b9b2f7402ae/f723af2d-9681-4c69-ad70-10e3ebadb8c6/3firefighter.png',
            isCorrect: false,
            id: 3,
          },
        ],
        type: 'MULTIPLECHOICE',
        optionType: 'LISTENPICTURE',
        grade: 'PREINTERMEDIATE',
        title: 'Listen and choose correct image.',
        subTile: 'Nghe và chọn hình ảnh mô tả đúng.',
        componentType: 'MultipleChoice',
        settings: {
          answers: {
            bulletType: 'character',
            imageAnswers: true,
            columnImageAnswers: 3,
          },
        },
        audioUrl: 'https://cloud.softech.vn/storage/SACHSO/t_SACHSO_RESOURCES_Questions/46d30c13-3555-4395-8b83-4b9b2f7402ae/574959c6-2206-4aa2-bdce-c7456d188f3c/UNIT-1_CÂU-3.wav',
      },
      {
        id: 4816,
        questionText: 'She <said> her father <that> she <could go> shopping with <him> the following day.',
        answers: [
          {
            id: 1,
            answer: 'said ',
            isCorrect: true,
          },
          {
            id: 2,
            answer: 'that ',
            isCorrect: false,
          },
          {
            id: 3,
            answer: 'would go',
            isCorrect: false,
          },
          {
            id: 4,
            answer: 'him',
            isCorrect: false,
          },
        ],
        type: 'ErrorCorrection',
        optionType: 'ONECHOICE_READANSWERUNDERLINED',
        gradeCode: 'ELEMENTARY',
        title: 'Find the mistakes in the sentence.',
        subTitle: 'Tìm lỗi sai trong câu.',
        tags: 'Tất cả các lớp',
        gradeName: 'Nhận biết',
        componentType: 'MultipleChoice',
        skills: 'V',
        imageUrl: '',
        imageSvg: '',
        audioUrl: '',
        settings: {},
        status: 'PUBLIC',
        createBy: 23195,
      },
      {
        id: 4387,
        questionText: 'Identify the underlines letters that are pronounced differently from the others.',
        answers: [
          {
            answer: 'sleep<s>',
            isCorrect: false,
            id: 1,
          },
          {
            answer: 'want<s>',
            isCorrect: false,
            id: 2,
          },
          {
            answer: 'say<s>',
            isCorrect: true,
            id: 3,
          },
          {
            answer: 'start<s>',
            isCorrect: false,
            id: 4,
          },
        ],
        type: 'MULTIPLECHOICE',
        optionType: 'OneChoice_ChooseAnswerIndicateUnderlined',
        gradeCode: 'ELEMENTARY',
        title: 'Choose the correct answer to indicate the word whose underlined part differs from the other in pronunciation in each of the following questions.',
        subTitle: 'Chọn đáp án đúng để chỉ ra từ có phát âm khác với từ còn lại trong câu.',
        tags: 'LỚP 7',
        gradeName: 'Nhận biết',
        componentType: 'MultipleChoice',
        skills: 'P',
        imageUrl: null,
        imageSvg: '',
        audioUrl: null,
        settings: {},
        status: 'PUBLIC',
        createBy: 23195,
      },
      {
        id: 6757,
        questionText: '',
        answers: [
          {
            answer: 'stress<ed>',
            isCorrect: false,
            id: 1,
          },
          {
            answer: 'releas<ed>',
            isCorrect: false,
            id: 2,
          },
          {
            answer: 'access<ed>',
            isCorrect: false,
            id: 3,
          },
          {
            answer: 'rais<ed>',
            isCorrect: true,
            id: 4,
          },
        ],
        type: 'MULTIPLECHOICE',
        optionType: 'ONECHOICE_CHOOSEANSWERINDICATEUNDERLINED',
        gradeCode: 'ELEMENTARY',
        title: 'Choose the correct answer to indicate the word whose underlined part differs from the other in pronunciation in each of the following questions.',
        subTitle: 'Chọn đáp án đúng để chỉ ra từ có phát âm khác với từ còn lại trong câu.',
        tags: 'Lớp 11',
        gradeName: 'Nhận biết',
        componentType: 'MultipleChoice',
        skills: 'P',
        imageUrl: null,
        imageSvg: '',
        audioUrl: null,
        settings: {},
        status: 'PUBLIC',
        createBy: 42327,
      },
      {
        id: 6216,
        questionText: 'What does it say?',
        answers: [
          {
            answer: 'Visitors should not get too close to the animals.',
            isCorrect: false,
            id: 1,
          },
          {
            answer: 'Visitors can feed animal here.',
            isCorrect: false,
            id: 2,
          },
          {
            answer: 'Visitors are a danger to the animals.',
            isCorrect: false,
            id: 3,
          },
          {
            answer: 'Visitors must not give food to the animals.',
            isCorrect: true,
            id: 4,
          },
        ],
        type: 'MULTIPLECHOICE',
        optionType: 'ONECHOICE_LOOKATTHESIGNANDCHOOSEANSWER',
        gradeCode: 'PREINTERMEDIATE',
        title: 'Look at the sign. Choose the correct answer to each of the following questions.',
        subTitle: 'Nhìn vào dấu hiệu. Chọn câu trả lời đúng cho mỗi câu hỏi sau.',
        tags: 'Lớp 8',
        gradeName: 'Hiểu/ Thông hiểu',
        componentType: 'MultipleChoice',
        skills: 'V',
        imageUrl: 'https://cloud.softech.vn/storage/SACHSO/t_SACHSO_RESOURCES_Questions/46d30c13-3555-4395-8b83-4b9b2f7402ae/6d5cb4d8-4726-4875-9fe7-f039b4a48426/p9.png',
        imageSvg: '',
        audioUrl: null,
        settings: {},
        status: 'PUBLIC',
        createBy: 42327,
      },
      {
        id: 6126,
        questionText: 'Sarah wants to know __________.',
        answers: [
          {
            answer: 'if Janie will be available to go to the restaurant',
            isCorrect: false,
            id: 1,
          },
          {
            answer: 'if the food at the restaurant will be all right for Janie',
            isCorrect: true,
            id: 2,
          },
          {
            answer: 'if Janie wants to see the restaurant menu before Saturday',
            isCorrect: false,
            id: 3,
          },
          {
            answer: 'if Janie wants Sarah to pick her up on Saturday',
            isCorrect: false,
            id: 4,
          },
        ],
        type: 'MULTIPLECHOICE',
        optionType: 'ONECHOICE_LOOKATTHESIGNANDCHOOSEANSWER',
        gradeCode: 'PREINTERMEDIATE',
        title: 'Look at the sign. Choose the correct answer to each of the following questions.',
        subTitle: 'Nhìn vào dấu hiệu. Chọn câu trả lời đúng cho mỗi câu hỏi sau.',
        tags: 'Lớp 7',
        gradeName: 'Hiểu/ Thông hiểu',
        componentType: 'MultipleChoice',
        skills: 'V',
        imageUrl: 'https://cloud.softech.vn/storage/SACHSO/t_SACHSO_RESOURCES_Questions/46d30c13-3555-4395-8b83-4b9b2f7402ae/b3fa7243-7bde-4239-9061-a7b07f565276/p2.png',
        imageSvg: '',
        audioUrl: null,
        settings: {},
        status: 'PUBLIC',
        createBy: 42327,
      },
      {
        id: 4383,
        questionText: 'Identify the underlines letters that are pronounced differently from the others.',
        answers: [
          {
            answer: 'expensive',
            isCorrect: true,
            id: 1,
          },
          {
            answer: 'dangerous',
            isCorrect: false,
            id: 2,
          },
          {
            answer: 'quieter',
            isCorrect: false,
            id: 3,
          },
          {
            answer: 'cinema',
            isCorrect: false,
            id: 4,
          },
        ],
        type: 'MULTIPLECHOICE',
        optionType: 'OneChoice_ChooseAnswerIndicateOther',
        gradeCode: 'ELEMENTARY',
        title: 'Choose the correct answer to indicate the word that differs from the other three in the position of the primary stress in each of the following questions.',
        subTitle: 'Chọn đáp án đúng để chỉ ra từ có trọng âm khác với các từ còn lại trong câu sau.',
        tags: 'LỚP 6',
        gradeName: 'Nhận biết',
        componentType: 'MultipleChoice',
        skills: 'P',
        imageUrl: null,
        imageSvg: '',
        audioUrl: null,
        settings: {},
        status: 'PUBLIC',
        createBy: 23195,
      },
      {
        id: 5258,
        questionText: 'Identify the words whose main stresses are different from the others.',
        answers: [
          {
            answer: 'television',
            isCorrect: false,
            id: 1,
          },
          {
            answer: 'family',
            isCorrect: false,
            id: 2,
          },
          {
            answer: 'engineer',
            isCorrect: true,
            id: 3,
          },
          {
            answer: 'stereo',
            isCorrect: false,
            id: 4,
          },
        ],
        type: 'MULTIPLECHOICE',
        optionType: 'ONECHOICE_CHOOSEANSWERINDICATEOTHER',
        gradeCode: 'ELEMENTARY',
        title: 'Choose the correct answer to indicate the word that differs from the other three in the position of the primary stress in each of the following questions.',
        subTitle: 'Chọn đáp án đúng để chỉ ra từ có trọng âm khác với các từ còn lại trong câu sau.',
        tags: 'Lớp 6',
        gradeName: 'Nhận biết',
        componentType: 'MultipleChoice',
        skills: 'P',
        imageUrl: null,
        imageSvg: '',
        audioUrl: null,
        settings: {},
        status: 'PUBLIC',
        createBy: 42327,
      },
      {
        id: 4945,
        examinationId: 'D9CDC7C0-4680-497B-B57C-176370C8FB12',
        questionText: 'teddy bear',
        answers: [
          {
            answer: 'teddy bear',
          },
        ],
        type: 'UNSCRAMBLE',
        optionType: 'UNSCRAMBLEWORDS',
        grade: 'ELEMENTARY',
        title: 'Look at the letters,write the word.',
        subTitle: 'Sắp xếp các chữ cái sau thành từ, cụm từ có nghĩa.',
        componentType: 'UNSCRAMBLE',
        settings: {
          question: {
            shuffedType: 'character',
          },
        },
        audioUrl: null,
        imageUrl: 'https://cloud.softech.vn/storage/SACHSO/t_SACHSO_RESOURCES_Questions/46d30c13-3555-4395-8b83-4b9b2f7402ae/da12a138-ad52-466c-ab42-526c816c905e/71PkTr5BEpL.jpg',
        videoUrl: '',
        imageSVG: '',
      },
      {
        id: 5041,
        examinationId: 'D9CDC7C0-4680-497B-B57C-176370C8FB12',
        questionText: 'doctor',
        answers: [
          {
            answer: 'doctor',
          },
        ],
        type: 'UNSCRAMBLE',
        optionType: 'UNSCRAMBLEWORDS',
        grade: 'ELEMENTARY',
        title: 'Look at the letters,write the word.',
        subTitle: 'Sắp xếp các chữ cái sau thành từ, cụm từ có nghĩa.',
        componentType: 'UNSCRAMBLE',
        settings: {
          question: {
            shuffedType: 'character',
          },
        },
        audioUrl: null,
        imageUrl: 'https://cloud.softech.vn/storage/SACHSO/t_SACHSO_RESOURCES_Questions/46d30c13-3555-4395-8b83-4b9b2f7402ae/0db54db9-ea90-42a6-bff6-4d94a4719e47/1.jpg',
        videoUrl: '',
        imageSVG: '',
      },
      {
        id: 5054,
        examinationId: 'D9CDC7C0-4680-497B-B57C-176370C8FB12',
        questionText: 'farmer',
        answers: [
          {
            answer: 'farmer',
          },
        ],
        type: 'UNSCRAMBLE',
        optionType: 'UNSCRAMBLEWORDS',
        grade: 'ELEMENTARY',
        title: 'Look at the letters,write the word.',
        subTitle: 'Sắp xếp các chữ cái sau thành từ, cụm từ có nghĩa.',
        componentType: 'UNSCRAMBLE',
        settings: {
          question: {
            shuffedType: 'character',
          },
        },
        audioUrl: '',
        imageUrl: 'https://cloud.softech.vn/storage/SACHSO/t_SACHSO_RESOURCES_Questions/46d30c13-3555-4395-8b83-4b9b2f7402ae/24b8ede6-dec6-49ed-a4ac-dab011c66752/7.jpg',
        videoUrl: '',
        imageSVG: '',
      },
      {
        id: 6466,
        questionText: 'We should practice for the show, shouldn’t we?',
        answers: [
          {
            answer: 'We should practice for the show, shouldn’t we?',
          },
        ],
        type: 'UNSCRAMBLE',
        optionType: 'MAKESENTENCE',
        gradeCode: 'PREINTERMEDIATE',
        title: 'Rearrange the words in a correct order to make complete sentences.',
        subTitle: 'Sắp xếp lại các từ theo đúng thứ tự để tạo thành câu hoàn chỉnh.',
        tags: 'Lớp 8',
        gradeName: 'Hiểu/ Thông hiểu',
        componentType: 'UNSCRAMBLE',
        skills: 'V',
        imageUrl: null,
        imageSvg: '',
        audioUrl: null,
        settings: {
          question: {
            shuffedType: 'word',
          },
        },
        status: 'PUBLIC',
        createBy: 42327,
      },
      {
        id: 6242,
        questionText: 'Last summer, I went on an adventure to climb a mountain.',
        answers: [
          {
            answer: 'Last summer, I went on an adventure to climb a mountain.',
          },
        ],
        type: 'UNSCRAMBLE',
        optionType: 'MAKESENTENCE',
        gradeCode: 'PREINTERMEDIATE',
        title: 'Rearrange the words in a correct order to make complete sentences.',
        subTitle: 'Sắp xếp lại các từ theo đúng thứ tự để tạo thành câu hoàn chỉnh.',
        tags: 'Lớp 8',
        gradeName: 'Hiểu/ Thông hiểu',
        componentType: 'UNSCRAMBLE',
        skills: 'V',
        imageUrl: null,
        imageSvg: '',
        audioUrl: null,
        settings: {
          question: {
            shuffedType: 'word',
          },
        },
        status: 'PUBLIC',
        createBy: 42327,
      },
      {
        id: 6135,
        questionText: 'I | want to | go to | school',
        answers: [
          {
            answer: 'I | want to | go to | school',
          },
        ],
        type: 'UNSCRAMBLE',
        optionType: 'MAKESENTENCE_WORDSGROUP',
        gradeCode: 'ELEMENTARY',
        title: 'Rearrange the groups of words in a correct order to make complete sentences.',
        subTitle: 'Sắp xếp lại các nhóm từ theo đúng thứ tự để tạo thành câu hoàn chỉnh.',
        tags: 'TẤT CẢ',
        gradeName: 'Nhận biết',
        componentType: 'UNSCRAMBLE',
        skills: 'V',
        imageUrl: '',
        imageSvg: '',
        audioUrl: '',
        settings: {},
        status: 'PUBLIC',
        createBy: 23195,
      },
      //COMBINE
      {
        id: 5699,
        questionText:
          "Kim really enjoyed attending high school in Seoul. His school had over two thousand students and was very modern with state-of-the-art classrooms and facilities. The curriculum focused heavily on academics, especially maths, science and languages. Students had to wear uniforms and strict rules about behaviour were enforced. However, Kim's favourite part of school was the extracurricular activities. He joined the basketball team, debate club and music club where he learned to play the guitar. He made lots of good friends through these activities who he still keeps in contact with. Although the workload and pressure to achieve were high, Kim looks back fondly at his school years as some of the most enjoyable times in his life.",
        answers: [
          {
            id: 5697,
            type: 'MULTIPLECHOICE',
            optionType: 'ONECHOICE_CHOOSEANSWER',
            questionText: "What was Kim's favourite part of school?\n",
            answers: [
              {
                id: 1,
                answer: 'Wearing uniforms',
                isCorrect: false,
              },
              {
                answer: 'Extracurricular activities',
                isCorrect: true,
                id: 2,
              },
              {
                answer: 'Strict rules about behaviour',
                isCorrect: false,
                id: 3,
              },
              {
                answer: 'Academics',
                isCorrect: false,
                id: 4,
              },
            ],
            imageUrl: '',
            audioUrl: '',
            grade: 'PREINTERMEDIATE',
            unit: '',
            settings: {},
            notes: '',
            videoUrl: '',
            imageSVG: '',
            componentType: 'MultipleChoice',
          },
          {
            id: 5698,
            type: 'MULTIPLECHOICE',
            optionType: 'ONECHOICE_CHOOSEANSWER',
            questionText: "What were the main subjects focused on in Kim's school curriculum?\n",
            answers: [
              {
                id: 1,
                answer: 'Arts and crafts',
                isCorrect: false,
              },
              {
                answer: 'Sports and music',
                isCorrect: false,
                id: 2,
              },
              {
                answer: 'History and geography',
                isCorrect: false,
                id: 3,
              },
              {
                answer: 'Maths, science, and languages',
                isCorrect: true,
                id: 4,
              },
            ],
            imageUrl: '',
            audioUrl: '',
            grade: 'PREINTERMEDIATE',
            unit: '',
            settings: {},
            notes: '',
            videoUrl: '',
            imageSVG: '',
            componentType: 'MultipleChoice',
          },
        ],
        type: 'COMBINE',
        optionType: 'COMBINE_READWRITEONEWORD',
        gradeCode: 'PREINTERMEDIATE',
        title: 'Read and write one-word answer',
        subTitle: 'Đọc và viết một từ',
        tags: 'LỚP 6',
        gradeName: 'Hiểu/ Thông hiểu',
        componentType: 'CombineWithAudio',
        skills: 'R',
        imageUrl: '',
        imageSvg: '',
        audioUrl: '',
        settings: {},
        status: 'PUBLIC',
        createBy: 42327,
      },
      {
        id: 5498,
        questionText:
          "In the zoo, there are many fascinating animals. One of the most interesting is the giraffe. These tall creatures have long necks and spots on their fur. Did you know that giraffes are the tallest land animals in the world? They use their long necks to reach leaves on tall trees, which other animals can't reach. Giraffes are also very social animals and live in groups called towers. They communicate with each other by making low humming noises and head-butting. It's amazing to see these majestic animals up close and learn more about their unique characteristics. Make sure to visit the giraffes on your next trip to the zoo!",
        answers: [
          {
            id: 5494,
            type: 'TICKTF',
            optionType: 'TICKTF_TRUEORFALSE',
            questionText: 'Giraffes have spots on their fur.',
            answers: [
              {
                id: 1,
                answer: '',
                isCorrect: true,
              },
            ],
            imageUrl: '',
            audioUrl: '',
            grade: 'PREINTERMEDIATE',
            unit: '',
            settings: {},
            notes: '',
            videoUrl: '',
            imageSVG: '',
            componentType: 'TickTF',
          },
          {
            id: 5495,
            type: 'TICKTF',
            optionType: 'TICKTF_TRUEORFALSE',
            questionText: 'Giraffes are the shortest land animals in the world.\n',
            answers: [
              {
                id: 1,
                answer: '',
                isCorrect: false,
              },
            ],
            imageUrl: '',
            audioUrl: '',
            grade: 'PREINTERMEDIATE',
            unit: '',
            settings: {},
            notes: '',
            videoUrl: '',
            imageSVG: '',
            componentType: 'TickTF',
          },
          {
            id: 5496,
            type: 'TICKTF',
            optionType: 'TICKTF_TRUEORFALSE',
            questionText: 'Giraffes use their long necks to reach leaves on tall trees.',
            answers: [
              {
                id: 1,
                answer: '',
                isCorrect: true,
              },
            ],
            imageUrl: '',
            audioUrl: '',
            grade: 'PREINTERMEDIATE',
            unit: '',
            settings: {},
            notes: '',
            videoUrl: '',
            imageSVG: '',
            componentType: 'TickTF',
          },
          {
            id: 5497,
            type: 'TICKTF',
            optionType: 'TICKTF_TRUEORFALSE',
            questionText: 'Giraffes are solitary animals and do not live in groups.',
            answers: [
              {
                id: 1,
                answer: '',
                isCorrect: false,
              },
            ],
            imageUrl: '',
            audioUrl: '',
            grade: 'PREINTERMEDIATE',
            unit: '',
            settings: {},
            notes: '',
            videoUrl: '',
            imageSVG: '',
            componentType: 'TickTF',
          },
        ],
        type: 'COMBINE',
        optionType: 'COMBINE_READWRITEONEWORD',
        gradeCode: 'PREINTERMEDIATE',
        title: 'Read and write one-word answer',
        subTitle: 'Đọc và viết một từ',
        tags: 'LỚP 6',
        gradeName: 'Hiểu/ Thông hiểu',
        componentType: 'CombineWithAudio',
        skills: 'R',
        imageUrl: '',
        imageSvg: '',
        audioUrl: '',
        settings: {},
        status: 'PUBLIC',
        createBy: 42327,
      },
      {
        id: 5804,
        questionText:
          "This year, there are even more events than previously. For a full list of events, go to the festival’s website at www.foodanddrinkfestival.com. The main event is 'Taste, Dine, and Learn.' As always, it is held in Albert Square in the heart of the city. At the Taste tent this year, you can enjoy cuisine from across the Mediterranean, and if you have a sweet tooth, you can finish your sampling with Italian ice cream! For a real taste of Manchester, visit the Dine tent with its dishes from twenty-five of the city’s finest restaurants. This is one meal that you cannot afford to miss. If the tricks of the trade interest you, then make your way to the Learn tent, where some familiar faces from TV will guide you through the steps that led to the delicious food on your plate.",
        answers: [
          {
            id: 5800,
            type: 'TICKTF',
            optionType: 'TICKTF_TRUEORFALSE',
            questionText: 'There were more events last year than this year.\n',
            answers: [
              {
                id: 1,
                answer: '',
                isCorrect: false,
              },
            ],
            imageUrl: '',
            audioUrl: '',
            grade: 'PREINTERMEDIATE',
            unit: '',
            settings: {},
            notes: '',
            videoUrl: '',
            imageSVG: '',
            componentType: 'TickTF',
          },
          {
            id: 5801,
            type: 'TICKTF',
            optionType: 'TICKTF_TRUEORFALSE',
            questionText: 'The main event is held at a different place this year.\n',
            answers: [
              {
                id: 1,
                answer: '',
                isCorrect: false,
              },
            ],
            imageUrl: '',
            audioUrl: '',
            grade: 'PREINTERMEDIATE',
            unit: '',
            settings: {},
            notes: '',
            videoUrl: '',
            imageSVG: '',
            componentType: 'TickTF',
          },
          {
            id: 5802,
            type: 'TICKTF',
            optionType: 'TICKTF_TRUEORFALSE',
            questionText: 'You can taste ice cream if you visit the Taste tent.\n',
            answers: [
              {
                id: 1,
                answer: '',
                isCorrect: true,
              },
            ],
            imageUrl: '',
            audioUrl: '',
            grade: 'PREINTERMEDIATE',
            unit: '',
            settings: {},
            notes: '',
            videoUrl: '',
            imageSVG: '',
            componentType: 'TickTF',
          },
          {
            id: 5803,
            type: 'TICKTF',
            optionType: 'TICKTF_TRUEORFALSE',
            questionText: 'You will be instructed step-by-step to make food if you visit Learn tent.\n',
            answers: [
              {
                id: 1,
                answer: '',
                isCorrect: true,
              },
            ],
            imageUrl: '',
            audioUrl: '',
            grade: 'PREINTERMEDIATE',
            unit: '',
            settings: {},
            notes: '',
            videoUrl: '',
            imageSVG: '',
            componentType: 'TickTF',
          },
        ],
        type: 'COMBINE',
        optionType: 'COMBINE_READWRITEONEWORD',
        gradeCode: 'PREINTERMEDIATE',
        title: 'Read and write one-word answer',
        subTitle: 'Đọc và viết một từ',
        tags: 'LỚP 8',
        gradeName: 'Hiểu/ Thông hiểu',
        componentType: 'CombineWithAudio',
        skills: 'R',
        imageUrl: '',
        imageSvg: '',
        audioUrl: '',
        settings: {},
        status: 'PUBLIC',
        createBy: 42327,
      },
      {
        id: 5772,
        questionText:
          '(1)____ February of 1962, John Glenn (2)____ space history. This American (3)____ climbed aboard a tiny space capsule called The Friendship 7. He travelled 160 miles above Earth, orbited the planet three times, and then safely returned (4)____ the Earth. Many years later, at the age of 77, he became the (5)____ person ever to fly in space. His adventure showed space scientists (6)____ space travel affects older people.',
        answers: [
          {
            id: 5766,
            type: 'MULTIPLECHOICE',
            optionType: 'ONECHOICE_CHOOSEANSWER',
            questionText: '',
            answers: [
              {
                id: 1,
                answer: 'A. To',
                isCorrect: false,
              },
              {
                answer: 'In',
                isCorrect: true,
                id: 2,
              },
              {
                answer: 'On',
                isCorrect: false,
                id: 3,
              },
              {
                answer: 'At',
                isCorrect: false,
                id: 4,
              },
            ],
            imageUrl: '',
            audioUrl: '',
            grade: 'PREINTERMEDIATE',
            unit: '',
            settings: {},
            notes: '',
            videoUrl: '',
            imageSVG: '',
            componentType: 'MultipleChoice',
          },
          {
            id: 5767,
            type: 'MULTIPLECHOICE',
            optionType: 'ONECHOICE_CHOOSEANSWER',
            questionText: '',
            answers: [
              {
                id: 1,
                answer: 'did',
                isCorrect: false,
              },
              {
                answer: 'invented',
                isCorrect: false,
                id: 2,
              },
              {
                answer: 'introduced',
                isCorrect: false,
                id: 3,
              },
              {
                answer: 'made',
                isCorrect: true,
                id: 4,
              },
            ],
            imageUrl: '',
            audioUrl: '',
            grade: 'PREINTERMEDIATE',
            unit: '',
            settings: {},
            notes: '',
            videoUrl: '',
            imageSVG: '',
            componentType: 'MultipleChoice',
          },
          {
            id: 5768,
            type: 'MULTIPLECHOICE',
            optionType: 'ONECHOICE_CHOOSEANSWER',
            questionText: '',
            answers: [
              {
                id: 1,
                answer: 'astronaut',
                isCorrect: true,
              },
              {
                answer: 'astronomer',
                isCorrect: false,
                id: 2,
              },
              {
                answer: 'pilot',
                isCorrect: false,
                id: 3,
              },
              {
                answer: 'inventor',
                isCorrect: false,
                id: 4,
              },
            ],
            imageUrl: '',
            audioUrl: '',
            grade: 'PREINTERMEDIATE',
            unit: '',
            settings: {},
            notes: '',
            videoUrl: '',
            imageSVG: '',
            componentType: 'MultipleChoice',
          },
          {
            id: 5769,
            type: 'MULTIPLECHOICE',
            optionType: 'ONECHOICE_CHOOSEANSWER',
            questionText: '',
            answers: [
              {
                id: 1,
                answer: 'to',
                isCorrect: true,
              },
              {
                answer: 'back',
                isCorrect: false,
                id: 2,
              },
              {
                answer: 'on',
                isCorrect: false,
                id: 3,
              },
              {
                answer: 'from',
                isCorrect: false,
                id: 4,
              },
            ],
            imageUrl: '',
            audioUrl: '',
            grade: 'PREINTERMEDIATE',
            unit: '',
            settings: {},
            notes: '',
            videoUrl: '',
            imageSVG: '',
            componentType: 'MultipleChoice',
          },
          {
            id: 5770,
            type: 'MULTIPLECHOICE',
            optionType: 'ONECHOICE_CHOOSEANSWER',
            questionText: '',
            answers: [
              {
                id: 1,
                answer: 'oldest',
                isCorrect: true,
              },
              {
                answer: 'youngest',
                isCorrect: false,
                id: 2,
              },
              {
                answer: 'bravest',
                isCorrect: false,
                id: 3,
              },
              {
                answer: 'earliest',
                isCorrect: false,
                id: 4,
              },
            ],
            imageUrl: '',
            audioUrl: '',
            grade: 'PREINTERMEDIATE',
            unit: '',
            settings: {},
            notes: '',
            videoUrl: '',
            imageSVG: '',
            componentType: 'MultipleChoice',
          },
          {
            id: 5771,
            type: 'MULTIPLECHOICE',
            optionType: 'ONECHOICE_CHOOSEANSWER',
            questionText: '',
            answers: [
              {
                id: 1,
                answer: 'who',
                isCorrect: false,
              },
              {
                answer: 'whose',
                isCorrect: false,
                id: 2,
              },
              {
                answer: 'whom',
                isCorrect: false,
                id: 3,
              },
              {
                answer: 'how',
                isCorrect: true,
                id: 4,
              },
            ],
            imageUrl: '',
            audioUrl: '',
            grade: 'PREINTERMEDIATE',
            unit: '',
            settings: {},
            notes: '',
            videoUrl: '',
            imageSVG: '',
            componentType: 'MultipleChoice',
          },
        ],
        type: 'COMBINE',
        optionType: 'COMBINE_READWRITEONEWORD',
        gradeCode: 'PREINTERMEDIATE',
        title: 'Read and write one-word answer',
        subTitle: 'Đọc và viết một từ',
        tags: 'LỚP 7',
        gradeName: 'Hiểu/ Thông hiểu',
        componentType: 'CombineWithAudio',
        skills: 'V',
        imageUrl: '',
        imageSvg: '',
        audioUrl: '',
        settings: {},
        status: 'PUBLIC',
        createBy: 42327,
      },
    ],
  },
  totalQuestion: 5,
  duration: 0,
};

export {fakeData};